require('./dist/ng-file-upload-all');
module.exports = 'ngFileUpload';


//////////////////
// WEBPACK FOOTER
// ./~/ng-file-upload/index.js
// module id = 262
// module chunks = 0